import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: () => import('@/view/index.vue')
    },
    // {
    //   path: "/consult",
    //   name: 'consult',
    //   component: () => import("@/view/consult/index.vue")
    // },
    // 资讯详情
    {
      path: "/consult_details",
      name: 'consult_details',
      component: () => import("@/view/consult/details.vue")
    },

    // 科目二 标准规则
    {
      path: "/kemuerExamStandards",
      name: 'kemuerExamStandards',
      component: () => import("@/view/kemuer/examStandards.vue")
    },
    // 科目二 注意事项

    {
      path: "/kemuerMattersNeedingAttention",
      name: 'kemuerMattersNeedingAttention',
      component: () => import("@/view/kemuer/mattersNeedingAttention.vue")
    },

    // 科目二 考试流程
    // examProcess
    {
      path: "/kemuerExamProcess",
      name: 'kemuerExamProcess',
      component: () => import("@/view/kemuer/examProcess.vue")
    },

    // 科目三 标准规则
    {
      path: "/kemusanExamStandards",
      name: 'kemusanExamStandards',
      component: () => import("@/view/kemusan/examStandards.vue")
    },
    // 科目三 注意事项

    {
      path: "/kemusanMattersNeedingAttention",
      name: 'kemusanMattersNeedingAttention',
      component: () => import("@/view/kemusan/mattersNeedingAttention.vue")
    },

    // 科目三 考试流程
    // examProcess
    {
      path: "/kemusanExamProcess",
      name: 'kemusanExamProcess',
      component: () => import("@/view/kemusan/examProcess.vue")
    },


    //  相关法规详情
    {
      path: "/laws_details",
      name: 'laws_details',
      component: () => import("@/view/laws/details.vue")
    },

    // 机动车驾驶证申领和使用规定
    {
      path: "/jdcjszslhsygd",
      name: 'jdcjszslhsygd',
      component: () => import("@/view/laws/jdcjszslhsygd.vue")
    },
    // 中华人民共和国道路交通安全法
    {
      path: "/zhrmghgdljtaqf",
      name: 'zhrmghgdljtaqf',
      component: () => import("@/view/laws/zhrmghgdljtaqf.vue")
    },
    // 中华人民共和国道路交通安全法实施条例
    {
      path: "/zhrmghgdljtaqfsstl",
      name: 'zhrmghgdljtaqfsstl',
      component: () => import("@/view/laws/zhrmghgdljtaqfsstl.vue")
    },
    // 机动车登记规定
    {
      path: "/jdcdjgd",
      name: 'jdcdjgd',
      component: () => import("@/view/laws/jdcdjgd.vue")
    },
    // 机动车交通事故责任强制保险条例
    {
      path: "/jdcjtsgzrqzbxtl",
      name: 'jdcjtsgzrqzbxtl',
      component: () => import("@/view/laws/jdcjtsgzrqzbxtl.vue")
    },
    // 道路交通安全违法行为记分管理办法
    {
      path: "/dljtaqwfxwjfglbf",
      name: 'dljtaqwfxwjfglbf',
      component: () => import("@/view/laws/dljtaqwfxwjfglbf.vue")
    },
    // 关于我们
    {
      path: "/aboutUs",
      name: 'aboutUs',
      component: () => import("@/view/setup/aboutUs.vue")
    },

    //  帮助中心
    {
      path: "/help",
      name: 'help',
      component: () => import("@/view/help/index.vue")
    },

    // 安全中心
    {
      path: "/securityCenter",
      name: 'securityCenter',
      component: () => import("@/view/setup/securityCenter.vue")
    },
    // 苹果订阅自动续费协议
    {
      path: "/appleSubscriptionAutomaticRenewalAgreement",
      name: 'appleSubscriptionAutomaticRenewalAgreement',
      component: () => import("@/view/setup/appleSubscriptionAutomaticRenewalAgreement.vue")
    },
    // 会员支付宝订阅协议
    {
      path: "/memberAlipaySubscriptionAgreement",
      name: 'memberAlipaySubscriptionAgreement',
      component: () => import("@/view/setup/memberAlipaySubscriptionAgreement.vue")
    },
    {
      path: "/loginPolicy",
      name: 'memberAlipaySubscriptionAgreement',
      component: () => import("@/view/setup/loginPolicy.vue")
    },
    // 权限声明
    {
      path: "/permissionStatement",
      name: 'permissionStatement',
      component: () => import("@/view/setup/permissionStatement.vue")
    },
    // 个人信息保护指引
    {
      path: "/personalInformationProtectionGuidelines",
      name: 'personalInformationProtectionGuidelines',
      component: () => import("@/view/setup/personalInformationProtectionGuidelines.vue")
    },
    // 隐私政策
    {
      path: "/PrivacyPolicy",
      name: 'PrivacyPolicy',
      component: () => import("@/view/setup/PrivacyPolicy.vue")
    },
    // 第三方sdk
    {
      path: "/thirdPartySDK",
      name: 'thirdPartySDK',
      component: () => import("@/view/setup/thirdPartySDK.vue")
    },
    // vip会员协议
    {
      path: "/vipMembershipAgreement",
      name: 'vipMembershipAgreement',
      component: () => import("@/view/setup/vipMembershipAgreement.vue")
    },
    // 会员协议
    {
      path: "/userAgreement",
      name: 'userAgreement',
      component: () => import("@/view/setup/userAgreement.vue")
    },
    // 知识点
    {
      path: "/knowledgePoints",
      name: 'knowledgePoints',
      component: () => import("@/view/knowledgePoints/knowledgePoints.vue")
    },


    // 个人信息收集清单
    {
      path: "/personalInformationCollectionChecklist",
      name: 'personalInformationCollectionChecklist',
      component: () => import("@/view/personalInformationCollectionChecklist/index.vue")
    },


    // 基本信息
    {
      path: "/basicInformation",
      name: 'basicInformation',
      component: () => import("@/view/personalInformationCollectionChecklist/basicInformation.vue")
    },
    //  查询成绩
    {
      path: "/queryGrades",
      name: "queryGrades",
      component: () => import("@/view/queryGrades/index.vue")
    },
    // 考试预约流程
    {
      path: "/examReservationProcess",
      name: "examReservationProcess",
      component: () => import("@/view/examReservationProcess/index.vue")
    },
    // 科目一考试标准
    {
      path: "/kemuyiExamStandards",
      name: "kemuyiExamStandards",
      component: () => import("@/view/kemuyi/examStandards.vue")
    },
     // 科目四考试标准
     {
      path: "/kemusiExamStandards",
      name: "kemusiExamStandards",
      component: () => import("@/view/kemusi/examStandards.vue")
    },




    //免责声明
    {
      path: "/disclaimer",
      name: 'disclaimer',
      component: () => import("@/view/android/Disclaimer.vue")
    },
    //自动续费服务协议
    {
      path: "/android/MARA",
      name: 'MARA',
      component: () => import("@/view/android/MARA.vue")
    },
    //会员协议
    {
      path: "/android/UserAgreement",
      name: 'android/UserAgreement',
      component: () => import("@/view/android/UserAgreement.vue")
    },
    //隐私协议
    {
      path: "/android/PrivacyPolicy",
      name: 'android/PrivacyPolicy',
      component: () => import("@/view/android/PrivacyPolicy.vue")
    },
    //注意事项【面诊】
    {
      path: "/face/Precautions",
      name: 'face/Precautions',
      component: () => import("@/view/android/tip_face.vue")
    },
    //注意事项【舌诊】
    {
      path: "/tongue/Precautions",
      name: 'tongue/Precautions',
      component: () => import("@/view/android/tip_tongue.vue")
    },
    // 会员支付宝订阅协议
    {
      path: "/android/memberAlipaySubscriptionAgreement",
      name: 'android/memberAlipaySubscriptionAgreement',
      component: () => import("@/view/android/memberAlipaySubscriptionAgreement.vue")
    },

    //ios 相关协议
    {
      path: "/iOS/MARA",
      name: 'ios/MARA',
      component: () => import("@/view/ios/MARA.vue")
    },
    //会员协议
    {
      path: "/iOS/UserAgreement",
      name: 'iOS/UserAgreement',
      component: () => import("@/view/android/UserAgreement.vue")
    },
    //隐私协议
    {
      path: "/iOS/PrivacyPolicy",
      name: 'iOS/PrivacyPolicy',
      component: () => import("@/view/ios/PrivacyPolicy.vue")
    },
    {
      path: "/iOS/SrcInfo",
      name: 'iOS/SrcInfo',
      component: () => import("@/view/ios/SrcInfo.vue")
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js